import { io } from "socket.io-client";
import parser from "socket.io-msgpack-parser";

export const socket =
  process.env.REACT_APP_BACKEND_URL &&
  process.env.REACT_APP_BACKEND_URL !== "" &&
  io(process.env.REACT_APP_BACKEND_URL, {
    parser,
    reconnectionAttempts: 5,
    reconnectionDelay: 30000,
  });

export const socketOutbid =
  process.env.REACT_APP_OUTBID_BACKEND_URL &&
  process.env.REACT_APP_OUTBID_BACKEND_URL !== "" &&
  io(process.env.REACT_APP_OUTBID_BACKEND_URL, {
    parser,
    reconnectionAttempts: 5,
    reconnectionDelay: 30000,
  });
